 
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MermaidService {
  chunks: string[] = [
    'Hey',
    ' Mark',
    'o',
    '!',
    " Let's",
    ' check',
    ' out',
    ' that',
    ' simple',
    ' two',
    '-block',
    ' Mermaid',
    ' diagram',
    ' one',
    ' more',
    ' time',
    ':\n\n',
    '```',
    'mer',
    'maid',
    '\n',
    'graph',
    ' TD',
    ';\n',
    '   ',
    ' A',
    '[',
    'Block',
    ' A',
    ']',
    ' -->',
    ' B',
    '[',
    'Block',
    ' B',
    '];\n',
    '``',
    '`\n\n',
    'This',
    ' shows',
    ' a',
    ' direct',
    ' link',
    ' from',
    ' "',
    'Block',
    ' A',
    '"',
    ' to',
    ' "',
    'Block',
    ' B',
    '."',
    ' Do',
    ' you',
    ' want',
    ' to',
    ' try',
    ' creating',
    ' a',
    ' more',
    ' complex',
    ' diagram',
    ',',
    ' or',
    ' is',
    ' there',
    ' something',
    ' else',
    " you're",
    ' curious',
    ' about',
    '?',
    ' Feel',
    ' free',
    ' to',
    ' ask',
    ' one',
    ' more',
    ' time',
    ':\n',
    '`',
    '``',
    'mer',
    'maid',
    '\n',
    'graph',
    ' TD',
    ';\n',
    '   ',
    ' X',
    '[',
    'Block',
    ' X',
    ']',
    ' -->',
    ' Y',
    '[',
    'Block',
    ' Y',
    '];\n',
    '``',
    '`\n\n',
    'This',
    ' shows',
    ' a',
    '!',
    ' 😊',
  ];

  buffer2: string[] = [];
  buffer4: string[] = [];
  final_message = '';
  mermaidBuffer: string[] = [];
  inMermaidBlock = false;
  mermaidCodeStart = false;
  outputBuffer: string[] = [];

  constructor() {
    // Error suppression is now handled globally in main.ts
  }

  runTest(): void {
    this.processChunks();
    console.log('Extracted mermaid text:', this.extractMermaidText());
    // console.log('Final message:', this.final_message);
    console.log('Mermaid content:', this.getMermaidContent());
  }

  processChunks(): void {
    for (const chunk of this.chunks) {
      this.buffer2.push(chunk);
      this.buffer4.push(chunk);
      this.final_message += chunk;

      // Maintain buffer2 size of 2
      if (this.buffer2.length > 2) {
        this.buffer2.shift();
      }

      // Maintain buffer4 size of 4
      if (this.buffer4.length > 4) {
        this.buffer4.shift();
      }

      // Check for the start of a Mermaid block
      if (!this.inMermaidBlock && this.containsMermaid()) {
        this.inMermaidBlock = true;
        this.mermaidBuffer = []; // Reset the mermaid buffer
        this.mermaidBuffer.push('```mermaid'); // Add the start tag
        this.mermaidCodeStart = true;
        console.log('Started Mermaid block.');
      }

      // Accumulate content if inside a Mermaid block
      if (this.inMermaidBlock) {
        // Push the chunk to the mermaid buffer and the output buffer if not a code start
        if (!this.mermaidCodeStart) {
          this.mermaidBuffer.push(chunk);
        }
        this.mermaidCodeStart = false;

        // Check for the end of a Mermaid block
        if (this.containsCodeTicks()) {
          this.inMermaidBlock = false;
          // this.mermaidBuffer.push('```'); // Add the end tag explicitly
          console.log('Completed Mermaid block:', this.getMermaidContent());
          this.outputBuffer.push(this.getMermaidContent());
        }
      } else {
        this.outputBuffer.push(chunk);
      }

      // console.log('chunk:', chunk);
      // console.log('buffer4:', this.buffer4.join(''));
    }
    console.log('this.mermaidBuffer:', this.mermaidBuffer);
    console.log('this.outputBuffer:', this.outputBuffer);
  }

  containsMermaid(): boolean {
    const buffer4Text = this.buffer4.join('');
    return buffer4Text.includes('```mermaid');
  }

  containsCodeTicks(): boolean {
    const buffer2Text = this.buffer2.join('');
    return buffer2Text.includes('```');
  }

  extractMermaidText(): string {
    const joinedChunks = this.chunks.join('');
    const mermaidStart = joinedChunks.indexOf('```mermaid');
    const mermaidEnd = joinedChunks.indexOf('```', mermaidStart + 3);

    if (mermaidStart !== -1 && mermaidEnd !== -1) {
      return joinedChunks.substring(mermaidStart + 9, mermaidEnd).trim();
    }

    return '';
  }

  getMermaidContent(): string {
    // return this.mermaidBuffer.join('').replace('```mermaid', '').replace('```', '').trim();
    // return this.mermaidBuffer.join('').replace(/```mermaid.*```/s, '```mermaid```').trim();

    return this.mermaidBuffer.join('').trim();
  }
}
